import i18n from 'i18next'
import Backend from 'i18next-xhr-backend'
import { initReactI18next } from 'react-i18next'
import { isNull, setLanguage } from "./izUtils";

let lang = localStorage.getItem('E-DRAZBE.selectedLanguage');
if (isNull(lang)) {
  setLanguage();
  lang = localStorage.getItem('E-DRAZBE.selectedLanguage');
}

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    lng: lang,
    load: 'currentOnly',
    backend: {
      /* translation file path */
      loadPath: '/assets/i18n/{{ns}}/{{lng}}.json'
    },
    fallbackLng: 'sl-SI',
    // debug: false,
    ns: ['translations'],
    defaultNS: 'translations',
    interpolation: {
      escapeValue: false
    },
    react: {
      useSuspense: true
    }
  })

export default i18n
